// Auto-generated from contact.html. Verbatim redesign import. Do NOT edit.
export const MARKUP = `
<main>
<section class="c-hero">
<div class="wrap">
<h1>Talk to an <em>expert</em>.</h1>
<p>Connect with our team to discuss how T-REX Network can support your institutional tokenization requirements.</p>
</div>
</section>
<section class="c-body">
<div class="wrap">
<div class="card">

<form id="contactForm" novalidate="">
<div class="err hidden" id="formError"></div>
<div aria-hidden="true" style="position:absolute;left:-9999px;top:-9999px;height:0;width:0;overflow:hidden;">
<label>Website</label>
<input autocomplete="off" name="website" tabindex="-1" type="text"/>
</div>
<div class="row">
<div class="field">
<label for="inquirySelect">I am contacting as <span class="req">*</span></label>
<select id="inquirySelect" name="inquiry_type" required="">
<option value="" selected="" disabled="">Select one</option>
<option value="institution">An issuer or asset manager</option>
<option value="custodian">A bank, custodian or fund administrator</option>
<option value="builder">A builder or developer</option>
<option value="investor">An investor</option>
<option value="media">Press</option>
<option value="partner">A partner or other</option>
</select>
</div>
</div>
<div class="row two">
<div class="field">
<label for="cfName">Name <span class="req">*</span></label>
<input id="cfName" name="name" autocomplete="name" placeholder="Full name" required="" type="text"/>
</div>
<div class="field">
<label for="cfEmail">Work email <span class="req">*</span></label>
<input id="cfEmail" name="email" autocomplete="email" placeholder="you@institution.com" required="" type="email"/>
</div>
</div>
<div class="row two">
<div class="field">
<label for="cfCompany">Institution <span class="req">*</span></label>
<input id="cfCompany" name="company" autocomplete="organization" placeholder="Organisation" required="" type="text"/>
</div>
<div class="field">
<label for="cfRole">Role <span class="opt">Optional</span></label>
<input id="cfRole" name="role" autocomplete="organization-title" placeholder="Title" type="text"/>
</div>
</div>
<div class="row">
<div class="field">
<label for="cfMessage">Message <span class="opt">Optional</span></label>
<textarea id="cfMessage" name="message" placeholder="Anything we should know before we reply. Assets, jurisdictions, timelines, or the question on your mind."></textarea>
</div>
</div>
<button class="btn-submit" id="submitBtn" type="submit">
<span id="submitLabel">Request a conversation</span>
<svg fill="none" id="submitArrow" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24"><line x1="5" x2="19" y1="12" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
</button>
<p class="assure">A member of the T-REX team reads every inquiry and replies personally within three business days. Your details are used only to answer you.</p>
</form>

<div class="success hidden" id="successState">
<div class="success-ring">
<svg fill="none" height="22" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="22"><polyline points="20 6 9 17 4 12"></polyline></svg>
</div>
<h3>Thank you. Your inquiry is with the team.</h3>
<p>The right person will reply by email within three business days. Your reference is <span class="ref" id="successRef"></span>.</p>
<button id="resetBtn" type="button">Send another inquiry</button>
</div>
</div>

<div class="next">
<div class="next-row">
<div class="next-step"><span class="next-num">1</span><span>We read your inquiry</span></div>
<svg class="next-arrow" fill="none" height="16" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="16"><polyline points="9 18 15 12 9 6"></polyline></svg>
<div class="next-step"><span class="next-num">2</span><span>The right person replies</span></div>
<svg class="next-arrow" fill="none" height="16" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="16"><polyline points="9 18 15 12 9 6"></polyline></svg>
<div class="next-step"><span class="next-num">3</span><span>We arrange a conversation</span></div>
</div>
</div>
</div>
</section>
</main>
`;
